"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getInvoices = exports.getInvoicePdf = void 0;
var _invoiceApi = _interopRequireDefault(require("../csc/api/invoiceApi"));
var _invoiceApi2 = _interopRequireDefault(require("../cic/api/invoiceApi"));
var _mainConfig = require("../mainConfig");
var currentApiSet = _mainConfig.isCICContentTree ? _invoiceApi2.default : _invoiceApi.default;
var getInvoices = exports.getInvoices = currentApiSet.getInvoices,
  getInvoicePdf = exports.getInvoicePdf = currentApiSet.getInvoicePdf;